// extracted by mini-css-extract-plugin
export default {"unavailableItem":"UnavailableItem_unavailableItem__e2Mdh"};